<template>
    <section class="section">
        <router-view
            v-if="sessid"
            :key="$route.name"
            :sessid="sessid"
            :isMobile="isMobile"
        />
    </section>
</template>

<script>

export default {
    name: "OrderPage",
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        sessid: {
            type: String,
            default: BX.bitrix_sessid()
        },
    },
}
</script>

<style lang="scss">
@import "../../../../design_kit/site/blocks/cart/style.scss";
@import "../../../../design_kit/site/blocks/popup/style.scss";
@import "../../../../design_kit/site/blocks/chbox/style.scss";
@import "../../../../design_kit/site/blocks/input/style.scss";
@import "../../../../design_kit/site/blocks/button/style.scss";
@import "../../../../design_kit/site/blocks/grid/style.scss";

#order-page .section {
    padding: 35px 0;
}

@media (min-width: 768px) {
    #order-page .section {
        padding: 50px 0;
    }
}

.modal-content {
    position: relative;
}

.hide {
    display: none;
}
</style>